import { Component, OnInit } from '@angular/core';
import { LoggedBaseComponent } from '../_components/LoggedBaseComponent';

@Component({
  selector: 'app-referee',
  templateUrl: './referee.component.html',
  styleUrls: ['./referee.component.css']
})
export class RefereeComponent extends LoggedBaseComponent implements  OnInit {
  
  default_redirect     = "dashboard/admin";
  normal_redirect      = "dashboard";
  redirect_to          = undefined;

  ngOnInit() {
    this.redirect_to = this._route.snapshot.queryParams['path'];
    if (!this._userService.isLogged()) {
        if (this.redirect_to) {
            this._router.navigate([""], { queryParams: { path: this.redirect_to } });
        }
    }
    else {
        var user_info = this.getUserInfo();
        if (this.redirect_to) {
            this._router.navigate([this.redirect_to]);
        } else {
            if (user_info["is_superuser"])
            {
              
            }
            else
            {
              this._router.navigate([this.normal_redirect]);
            }
            
        }
    }
  }

}
